<template>
  <div>

    <v-text-field label=" انتخاب کاربر" :value="name || oldData" dense
                  outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                  ref="input"/>

    <v-dialog v-model="dialog" scrollable max-width="800px">
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>
          انتخاب کاربر
          <v-spacer></v-spacer>
          <v-btn small icon rounded @click="delContact"
                 class="ml-1 text-danger">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-actions>
          <v-text-field clearable clear-icon="mdi-close-circle-outline" @click:clear="rebuild" label="جستجو"
                        append-icon="mdi-magnify"
                        v-model="tableProps.search"
                        hide-details class="my-3"/>
        </v-card-actions>

        <v-list style="background: white; z-index: 999">
          <v-list-item @click="pick(x)" v-for="(x,i) in manufacturers" :key="i">

            <v-list-item-content>
              <v-list-item-title v-text="x.name + ' ' +x.lastName "/>
              <v-list-item-subtitle v-text="x.username">
              </v-list-item-subtitle>
            </v-list-item-content>


            <v-list-item-action v-if="x.id === value">
              <v-icon>mdi-check</v-icon><!--        <v-divider></v-divider>-->

            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-card-actions class="justify-end" style="background: white; z-index: 999">
          <hr>
          <v-spacer></v-spacer>

          <!--          <pagination :data="manufacturers.data" :visible="2" v-on:page="fetch(url, tableProps)"/>-->
          <Paginate :total="data.last_page" :links="data.links" :tableProps="tableProps"
                    @changePage="fetch(url, tableProps)"></Paginate>


          <v-btn outlined class="mr-auto btn-cancel" text
                 @click="dialog = false">
            <v-icon>mdi-close-circle</v-icon>
            <b>بستن</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Paginate from "@/view/pages/numbers/Paginate";
import {Bus} from "@/main";

export default {
  components: {Paginate},
  name: "UsersComponent",
  props: {
    oldData: {
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      search: null,
      manufacturers: [],
      data: {},
      name: null,
      model: [],
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      url: `${url}/admin/users`
    }
  },
  model: {
    prop: 'value',
    event: 'manufacturersPicker'
  },

  computed: {
    manufacturer_name: function () {
      if (this.model === null) return "";
      return this.model.name;
    },
  },

  watch: {
    model(val) {
      this.name = val.name
    },
    value(val) {
      if (val === null)
        return this.name = null
      return this.name = this.model.name
      // this.findModel();
    },
    'tableProps.search'(val) {
      if (val.length >= 3) {
        this.tableProps.search = val
        this.fetch(this.url, this.tableProps)
      }
    },
    oldData(val) {
      setTimeout(() => {
        this.pick(val)
      }, 1000)
    }
  },

  created() {
    this.fetch(this.url);

    this.manufacturers.find(x => {
      if (x.id === this.value) {
        this.manufacturer_name = x.name;
      }
    });
  },

  methods: {
    fetch(url = this.url, props = this.tableProps) {
      this.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        data: props,
        headers: {
          "ACCEPT": 'application/json',
          "Authorization": Token,
          "Content-Type": 'application/json'
        },
        msg: false,
        success: (data) => {
          this.data = data.data;
          this.loading = false;

          this.manufacturers = [{
            id: '-1',
            name: 'سایت',
            lastName: '',
            username: null
          }];

          this.manufacturers = this.manufacturers.concat(data.data.data)
        }
      })
    },
    delContact() {
      this.dialog = false;
      this.model = null
      this.name = '';
      this.oldData = null
      Bus.$emit('manufacturersPicker', null);
    },
    pick(x) {
      Bus.$emit('manufacturersPicker', x.id);
      this.model = x;
      this.dialog = false;
    },
    rebuild() {
      this.tableProps.search = '';
      this.fetch(this.url, this.tableProps)
    }
  }
}
</script>

<style scoped>

</style>
